import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * CaseFormPage - Redirect Component
 * 
 * In the participant-centric architecture, cases MUST be created under a 
 * program enrollment. This page redirects users to the appropriate participant
 * detail page where they can create a case under an enrollment.
 */
const CaseFormPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const participantId = searchParams.get('participant');

  useEffect(() => {
    if (participantId) {
      // Redirect to participant detail page with enrollments tab active
      toast.info('Cases must be created under a program enrollment');
      navigate(`/participants/${participantId}`, { replace: true });
    } else {
      // No participant specified, redirect to participants list
      toast.info('Please select a participant first, then create a case under their program enrollment');
      navigate('/participants', { replace: true });
    }
  }, [participantId, navigate]);

  return (
    <div className="flex items-center justify-center h-64">
      <Card className="card-shadow">
        <CardContent className="py-8 text-center">
          <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground">
            Redirecting to participant profile...
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            Cases are created under program enrollments.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CaseFormPage;
